/* ab-gallery-actions: share button on top of the first gallery tile.
   Markup: snippets/ab-gallery-actions.liquid, printed by main-product next to the gallery.
   The back link in the same element is a plain link and needs no script.
   Styles: ab-main-product.css. */
if (!customElements.get('ab-gallery-actions')) {
  customElements.define(
    'ab-gallery-actions',
    class AbGalleryActions extends HTMLElement {
      connectedCallback() {
        /* the element can be connected again when the section is redrawn: bind once */
        if (this.button) return;

        this.message = this.querySelector('.ab-gallery-actions__message');
        this.button = this.querySelector('.ab-gallery-actions__share-button');
        if (this.button) this.button.addEventListener('click', this.share.bind(this));
      }

      /* same order as the theme share button: system share sheet first, copy the link otherwise */
      share() {
        const url = this.shareUrl();

        if (navigator.share) {
          navigator.share({ url: url, title: this.dataset.title || document.title }).catch((error) => {
            /* closing the share sheet is not an error */
            if (error.name !== 'AbortError') this.copy(url);
          });
          return;
        }

        this.copy(url);
      }

      /* product address plus the variant the theme keeps in the address bar */
      shareUrl() {
        const url = new URL(this.dataset.url || window.location.href, window.location.href);
        const variant = new URLSearchParams(window.location.search).get('variant');
        if (variant) url.searchParams.set('variant', variant);
        return url.toString();
      }

      copy(url) {
        if (!navigator.clipboard) return;
        navigator.clipboard
          .writeText(url)
          .then(this.confirm.bind(this))
          .catch(() => {});
      }

      confirm() {
        if (!this.message) return;
        this.message.textContent = this.dataset.copied || '';
        this.classList.add('is-copied');
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(() => {
          this.message.textContent = '';
          this.classList.remove('is-copied');
        }, 2500);
      }
    }
  );
}
